import {Injectable} from '@angular/core';
import {Router, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './../services/authentication.service';
import { HeaderService } from '../template/header/header.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private auth: AuthenticationService, private router: Router, private headerService: HeaderService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.auth.currentUserValue;
        
        if (currentUser) {
            // check if route is restricted by role
            // if (route.data.roles && route.data.roles.indexOf(currentUser.admin) === -1)
            if (!route.data.dashboard) {
                // role not authorised so redirect to home page
                let isAdmin: boolean;
                this.headerService.getProfile()
                .subscribe(
                    data => {
                        console.log('Admin', data.admin)
                        isAdmin = data.admin
                        if (isAdmin){
                            // console.log('entre')
                            // console.log('WAAAAAAAAAAAAAAAAAAAAAAAAAa')
                            return true;
                        }
                        this.router.navigate(['/indicators']);
                        return false;
                    }
                )
                
            }
            // authorised so return true
            return true;
        }
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return false;
    }


    // canActivate(
    //     route: ActivatedRouteSnapshot,
    //     state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    //     if (!this.auth.isLoggedIn) {
    //       this.router.navigate(['/']);
    //       return false;
    //     } else {
    //       return true;
    //     }
    // }

}
